import React from "react";
import { useTranslation } from "@helpers/translate";
import { blurOnEnter } from "../../utils/input";

/**
 * @param {object} props
 */
export const RiskSettings = ({
  mode,
  saveRisk,
  tpDraft,
  slDraft,
  switchMode,
  toggleSaveRisk,
  onTpChange,
  onSlChange,
  onTpBlur,
  onSlBlur,
}) => {
  const { __ } = useTranslation();

  return (
    <div className="trade-form__risk" data-futures-guide="take-profit-stop-loss">
      <div className="trade-form__risk-head">
        <p className="trade-form__risk-label">{__("futures.trade_form.risk_settings")}</p>

        <div className="trade-form__mode" role="group" aria-label={__("futures.trade_form.risk_mode")}>
          <button
            type="button"
            className={`trade-form__mode-btn${mode === "$" ? " trade-form__mode-btn--active" : ""}`}
            aria-pressed={mode === "$"}
            onClick={() => switchMode("$")}
          >
            $
          </button>
          <button
            type="button"
            className={`trade-form__mode-btn${mode === "%" ? " trade-form__mode-btn--active" : ""}`}
            aria-pressed={mode === "%"}
            onClick={() => switchMode("%")}
          >
            %
          </button>
        </div>
      </div>

      <div className="trade-form__risk-list">
        <div className="trade-form__risk-row">
          <p className="trade-form__risk-label">{__("futures.tp_sl.take_profit")}</p>
          <div className="trade-form__risk-value">
            <span className="trade-form__risk-symbol">{mode}</span>
            <input
              className="trade-form__risk-input"
              value={tpDraft}
              onChange={onTpChange}
              onBlur={onTpBlur}
              onFocus={(event) => event.target.select()}
              onKeyDown={blurOnEnter}
              inputMode="decimal"
              aria-label={__("futures.tp_sl.take_profit")}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="trade-form__risk-row">
          <p className="trade-form__risk-label">{__("futures.tp_sl.stop_loss")}</p>
          <div className="trade-form__risk-value">
            <span className="trade-form__risk-symbol">{mode}</span>
            <input
              className="trade-form__risk-input"
              value={slDraft}
              onChange={onSlChange}
              onBlur={onSlBlur}
              onFocus={(event) => event.target.select()}
              onKeyDown={blurOnEnter}
              inputMode="decimal"
              aria-label={__("futures.tp_sl.stop_loss")}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="trade-form__risk-row trade-form__risk-row--save">
          <p className="trade-form__risk-label">{__("futures.mobile_trade.save_risk")}</p>
          <button
            type="button"
            className={`trade-form__switch${saveRisk ? " trade-form__switch--on" : ""}`}
            role="switch"
            aria-checked={saveRisk}
            aria-label={__("futures.mobile_trade.save_risk")}
            onClick={toggleSaveRisk}
          >
            <span className="trade-form__switch-knob" />
          </button>
        </div>
      </div>
    </div>
  );
};
